module.exports = __webpack_public_path__ + "static/media/default-logo.477282fd.svg";